export default function Version() {
    return (
        <>
            v1.0.4
        </>
    )
}